var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "modal-body-user-info" }, [
    _c("div", { staticClass: "description" }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.modalAction == _vm.actionTypes.createUser
              ? "Add a new user"
              : "Edit a user"
          ) +
          " by entering the information below.\n  "
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name row" }, [
      _c("div", { staticClass: "first-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("First name:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userInfo.firstName,
                expression: "userInfo.firstName"
              }
            ],
            staticClass: "input",
            attrs: {
              type: "text",
              name: "firstName",
              placeholder: "First Name"
            },
            domProps: { value: _vm.userInfo.firstName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userInfo, "firstName", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "last-name" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Last name:")]),
        _vm._v(" "),
        _c("div", [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required",
                expression: "'required'"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.userInfo.lastName,
                expression: "userInfo.lastName"
              }
            ],
            staticClass: "input",
            attrs: { type: "text", name: "lastName", placeholder: "Last Name" },
            domProps: { value: _vm.userInfo.lastName },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.userInfo, "lastName", $event.target.value)
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Email address:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userInfo.email,
              expression: "userInfo.email"
            }
          ],
          staticClass: "input",
          attrs: {
            name: "email",
            type: "text",
            placeholder: "E.g. hannah_welch@gmail.com"
          },
          domProps: { value: _vm.userInfo.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userInfo, "email", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "phone" }, [
      _c("div", { staticClass: "text" }, [_vm._v("Phone:")]),
      _vm._v(" "),
      _c("div", [
        _c("input", {
          directives: [
            {
              name: "the-mask",
              rawName: "v-the-mask",
              value: "+1(###)-###-####",
              expression: "'+1(###)-###-####'"
            },
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.userInfo.phoneNumber,
              expression: "userInfo.phoneNumber"
            }
          ],
          staticClass: "input",
          attrs: {
            name: "phone",
            type: "text",
            placeholder: "+1(###)-###-####"
          },
          domProps: { value: _vm.userInfo.phoneNumber },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.userInfo, "phoneNumber", $event.target.value)
            }
          }
        })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row role-client" }, [
      _c("div", { staticClass: "role" }, [
        _c("div", { staticClass: "text" }, [_vm._v("Role:")]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("Multiselect", {
              staticClass: "input",
              attrs: {
                label: "text",
                options: _vm.listUserRole,
                "track-by": "name",
                searchable: false,
                "close-on-select": true,
                "show-labels": false,
                placeholder: "Choose a role",
                openDirection: "below"
              },
              on: { select: _vm.selectRole },
              model: {
                value: _vm.role,
                callback: function($$v) {
                  _vm.role = $$v
                },
                expression: "role"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.showClientList
        ? _c("div", { staticClass: "client" }, [
            _c("div", { staticClass: "text" }, [_vm._v("Client:")]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("multiselect", {
                  staticClass: "input",
                  attrs: {
                    options: _vm.clientList,
                    placeholder: "Choose the client for this client",
                    label: "clientName",
                    openDirection: "below",
                    multiple: false,
                    "close-on-select": true,
                    "hide-selected": true,
                    "track-by": "id",
                    "allow-empty": true,
                    "show-labels": false,
                    "max-height": 174
                  },
                  on: { select: _vm.selectClient },
                  model: {
                    value: _vm.clientAccount,
                    callback: function($$v) {
                      _vm.clientAccount = $$v
                    },
                    expression: "clientAccount"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-ce69e6b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce69e6b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/UserInfo.vue
// module id = 1415
// module chunks = 1